import { useState } from "react";
import axios from "axios";
import { MailOpen } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailGate = ({ submissionId, onDone }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | error

  const submit = async (e) => {
    e.preventDefault();
    if (!email || state === "sending" || !submissionId) return;
    setState("sending");
    try {
      await axios.patch(`${API}/submissions/${submissionId}/email`, {
        email,
        name: name || null,
      });
      onDone(true);
    } catch {
      setState("error");
    }
  };

  return (
    <div data-testid="email-gate-screen" className="flex flex-col flex-1 justify-center">
      <div className="animate-fade-up rounded-3xl bg-white border border-[#E9DFD6] p-6 sm:p-10 shadow-[0_8px_30px_-4px_rgba(74,52,40,0.08)]">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FBEBE4] mb-5">
          <MailOpen className="w-6 h-6 text-[#B25E3B]" />
        </span>
        <h2 className="font-serif-display text-2xl sm:text-3xl leading-snug text-[#2C221E] mb-3">
          Before your result — we'd love to follow up with you personally.
        </h2>
        <p className="text-base text-[#5A4D46] leading-relaxed mb-7">
          Your answers tell us you're ready. Leave your name and email and we'll
          send you a copy of your result, plus a real note about your next step
          — from a human, not an autoresponder.
        </p>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <input
            data-testid="gate-name-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="First name (optional)"
            className="w-full rounded-xl border border-[#E9DFD6] bg-[#FCF9F5] px-4 py-3.5 text-base text-[#2C221E] placeholder:text-[#85746C]/70 focus:outline-none focus:ring-2 focus:ring-[#B25E3B] focus:border-transparent"
          />
          <input
            data-testid="gate-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email address"
            className="w-full rounded-xl border border-[#E9DFD6] bg-[#FCF9F5] px-4 py-3.5 text-base text-[#2C221E] placeholder:text-[#85746C]/70 focus:outline-none focus:ring-2 focus:ring-[#B25E3B] focus:border-transparent"
          />
          <button
            data-testid="gate-submit-btn"
            type="submit"
            disabled={state === "sending" || !submissionId}
            className="w-full rounded-full bg-[#B25E3B] hover:bg-[#9C4E2D] text-[#FAF7F2] font-semibold px-6 py-4 transition-colors duration-200 active:scale-[0.98] disabled:opacity-60"
          >
            {state === "sending" ? "Sending..." : "Send my copy & show my result"}
          </button>
          {state === "error" && (
            <p data-testid="gate-error" className="text-sm text-[#B25E3B]">
              Something didn't go through — please try again.
            </p>
          )}
        </form>
        <button
          data-testid="gate-skip-btn"
          onClick={() => onDone(false)}
          className="w-full text-center text-sm text-[#85746C] hover:text-[#B25E3B] transition-colors duration-200 mt-4 py-2"
        >
          No thanks — just show my result
        </button>
      </div>
    </div>
  );
};
